import { Button } from '@shared/components/ui/button';
import { EmptyView, EMPTY_VIEW_ICONS } from '@shared/components/ui/EmptyView';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreatePackagingButton } from '../interaction';
import { PackagingGridSkeleton } from '../skeletons';

interface PackagingStatesProps {
  isLoading: boolean;
  error: unknown;
  itemsCount: number;
  searchTerm: string;
  onRefetch: () => void;
  onCreatePackaging: () => void;
}

const PackagingStates: React.FC<PackagingStatesProps> = ({
  isLoading,
  error,
  itemsCount,
  searchTerm,
  onRefetch,
  onCreatePackaging,
}) => {
  const { t } = useTranslation('packagingModule');

  // Estado de carga inicial - Skeleton
  if (isLoading && itemsCount === 0) {
    return <PackagingGridSkeleton />;
  }

  // Estado de error
  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-destructive mb-4">{t('errors.network')}</p>
        <Button onClick={onRefetch} variant="outline" size="sm" data-testid="refetch-button">
          {t('button.loading')}
        </Button>
      </div>
    );
  }

  // Estado vacío
  if (!isLoading && !error && itemsCount === 0) {
    return (
      <EmptyView
        type={searchTerm ? 'noResults' : 'emptyState'}
        icon={EMPTY_VIEW_ICONS.ORDER_PREPARATION}
        customAction={searchTerm ? null : <CreatePackagingButton onCreatePackaging={onCreatePackaging} />}
      />
    );
  }

  return null;
};

export default PackagingStates;
